import { useTranslation } from 'react-i18next';
import { Moon, Sun } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { useTheme } from '@/providers';

export const ThemeToggle = () => {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();

  const nextTheme = theme === 'dark' ? 'light' : 'dark';
  const Icon = theme === 'dark' ? Sun : Moon;

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      className="border-border bg-muted text-foreground hover:bg-muted/80 hover:text-foreground size-8 border focus:ring-0 focus:ring-offset-0"
      aria-label={t(theme === 'dark' ? 'Light theme' : 'Dark theme')}
      title={`${t('Theme')}: ${theme === 'dark' ? t('Dark theme') : t('Light theme')}`}
      onClick={() => setTheme(nextTheme)}
    >
      <Icon className="size-4" />
    </Button>
  );
};
